<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List Position
        </span>
        <a-input
          placeholder="Search position..."
          style="width: 100%; max-width: 350px; margin-right: 5px;"
          v-model="filter.query"
          @change="onFilter"
        />
        <a-button-group style="margin-right: 5px;">
          <a-button
            @click="onChangeStatusFilter()"
            :type="!filter.status ? 'primary' : ''"
          >
            All
          </a-button>
          <a-button
            @click="onChangeStatusFilter('ACTIVE')"
            :type="filter.status === 'ACTIVE' ? 'primary' : ''"
          >
            Active
          </a-button>
          <a-button
            @click="onChangeStatusFilter('DEACTIVE')"
            :type="filter.status === 'DEACTIVE' ? 'primary' : ''"
          >
            Deactive
          </a-button>
        </a-button-group>
        <a-button slot="extra" type="primary" @click="showDrawerAddPosition">
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-drawer
        v-if="visibleAddPosition"
        title="Add New"
        placement="right"
        :visible="visibleAddPosition"
        @close="closeDrawerAddPosition"
        :width="450"
      >
        <AddPosition
          :createdPositionOnView="createdPositionOnView"
          :closeDrawerAddPosition="closeDrawerAddPosition"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleUpdatePosition"
        title="Edit"
        placement="right"
        :visible="visibleUpdatePosition"
        @close="closeDrawerUpdatePosition"
        :width="450"
      >
        <UpdatePosition
          :closeDrawerUpdatePosition="closeDrawerUpdatePosition"
          :idPosition="idPosition"
          :updatePositionOnView="updatePositionOnView"
          :deletePositionOnView="deletePositionOnView"
        />
      </a-drawer>

      <a-table
        :loading="loading"
        size="small"
        :columns="columnPosition"
        :data-source="listPosition"
        rowKey="id"
        style="margin-top: 5px;"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loading"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>

        <div slot="status" slot-scope="text, record">
          <p v-if="record.status === 'ACTIVE'">
            <a-icon type="check" style="marginleft: 5px; color: #52c419;" />
          </p>
        </div>

        <div slot="createdAt" slot-scope="text, record">
          <p>
            {{ record.createdAt | formatDateHour }}
          </p>
        </div>

        <div slot="updatedAt" slot-scope="text, record">
          <p>
            {{ record.updatedAt | formatDateHour }}
          </p>
        </div>

        <div slot="action" slot-scope="text, record">
          <a-button
            icon="edit"
            @click="showDrawerUpdatePosition(record)"
            class="icon-update"
          >
            Edit
          </a-button>
        </div>
      </a-table>
    </a-card>
  </div>
</template>
<script>
import AddPosition from "./components/addPosition";
import UpdatePosition from "./components/updatePosition";
import getQuery from "../data/getData";
import { columnPosition } from "../Constants/dataColumns";
import debounce from "lodash/debounce";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const limit = 10;
const startPage = 1;
const defaultFilter = { query: "", status: "ACTIVE" };
export default {
  components: {
    AddPosition,
    UpdatePosition,
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      idPosition: null,
      visibleAddPosition: false,
      visibleUpdatePosition: false,
      loading: true,
      columnPosition,
      listPosition: [],
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    showDrawerAddPosition() {
      this.visibleAddPosition = true;
    },
    closeDrawerAddPosition(position) {
      this.visibleAddPosition = false;
    },
    showDrawerUpdatePosition(record) {
      this.idPosition = record.id;
      this.visibleUpdatePosition = true;
    },
    closeDrawerUpdatePosition() {
      this.visibleUpdatePosition = false;
    },
    updatePositionOnView(item) {
      this.listPosition = updateForUpdated(this.listPosition, item);
    },
    createdPositionOnView(item) {
      this.listPosition = updateForCreated({
        list: this.listPosition,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    deletePositionOnView(item) {
      this.listPosition = updateForDeleted(this.listPosition, item);
    },

    getAllPosition(flag) {
      this.loading = true;
      this.$apollo
        .query({
          query: getQuery.queryGetAllPosition,
          variables: {
            status: this.filter.status,
            query: this.filter.query,
            limit,
            page: this.totalPage,
          },
        })
        .then(({ data }) => {
          if (data?.getAllPosition?.length >= 0) {
            if (flag === "FILTER") {
              this.listPosition = [...data.getAllPosition];
            } else if (flag === "PAGINATION") {
              this.listPosition = this.listPosition.concat([
                ...data.getAllPosition,
              ]);
            } else {
              this.listPosition = [...data.getAllPosition];
            }

            // check is pagniation
            if (data.getAllPosition.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          console.log("Không lấy được danh sách chức vụ", error);
        });
    },
    onChangeStatusFilter(status) {
      this.$set(this.filter, "status", status || undefined);
      this.onFilter();
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.getAllPosition("FILTER");
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.getAllPosition("PAGINATION");
      }
    },
  },
  created() {
    this.getAllPosition();
  },
};
</script>
